import React from "react";
import {FILE_STATUS_UPLOADED} from "../../../constants/FileStatusConstant";
import {useDispatch} from "react-redux";
import {fileDelete} from "../../../actions/FileActions";

function DeleteUploadedFileAction({file}) {
    if (file.status !== FILE_STATUS_UPLOADED) return null;

    const dispatch = useDispatch();

    const handleDeleteFile = () => {
        dispatch(fileDelete(file))
    }
    
    return <img
        className="file-list__delete-file"
        src="/_core/assets/themes/transcription/assets/img/transcription/ico02.svg"
        alt="Delete file"
        onClick={handleDeleteFile}
    />
}

export default DeleteUploadedFileAction